import { render, staticRenderFns } from "./runRecordDetailModal.vue?vue&type=template&id=54723905&scoped=true"
import script from "./runRecordDetailModal.vue?vue&type=script&lang=js"
export * from "./runRecordDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54723905",
  null
  
)

export default component.exports